import React, { useState } from 'react';
import ListHeroPhoto from '../ListHeroPhoto';
import { formatLocationDisplay, formatLocationOverride } from '../../utils/locationUtils';

function ArchivedListsSection({
  archivedLists,
  visitedPlaceIds,
  onListClick,
  onRestoreList,
  restoringListId,
}) {
  const [showArchived, setShowArchived] = useState(false);

  if (archivedLists.length === 0) return null;

  return (
    <div className="archived-section">
      <button
        className="archived-toggle"
        onClick={() => setShowArchived(!showArchived)}
      >
        <span>Archived ({archivedLists.length})</span>
        <svg
          className={`toggle-icon ${showArchived ? 'expanded' : ''}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {showArchived && (
        <div className="archived-list">
          {archivedLists.map((list) => {
            const items = list.items || [];
            const itemCount = list.itemCount ?? items.length;
            const completedCount = items.filter(p =>
              p.placeId && visitedPlaceIds.has(p.placeId)
            ).length;
            const percentComplete = itemCount > 0 ? Math.round((completedCount / itemCount) * 100) : 0;
            const placeCount = itemCount;
            const heroItem = list.heroItem || items.find(item => item.photoUrl);
            const locationDisplay = formatLocationOverride(list.locationOverride) || formatLocationDisplay(list.location) || list.location;
            const categoryDisplay = list.categoryOverride || list.category;
            const placeLabel = placeCount === 1 ? 'place' : 'places';

            return (
              <div
                key={list.id}
                className="list-preview-card archived"
                onClick={() => onListClick(list.id)}
              >
                <div className="list-preview-hero">
                  <ListHeroPhoto
                    placeId={heroItem?.placeId}
                    altText={list.title || list.name}
                    storedPhotoUrl={heroItem?.photoUrl}
                    photoUrlSavedAt={heroItem?.photoUrlSavedAt}
                    customPhoto={list.customPhoto}
                  />
                  <div className="list-hero-overlay archived-overlay" />
                  <div className="archived-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"/>
                    </svg>
                  </div>
                </div>
                <div className="list-preview-content">
                  <h3 className="list-preview-title">{list.title || list.name}</h3>
                  {!list.isOwned && list.ownerName && (
                    <div className="list-preview-owner">
                      <span className="owner-label">by {list.ownerName}</span>
                    </div>
                  )}
                  <div className="list-preview-subtitle">
                    {locationDisplay && <span>{locationDisplay}</span>}
                    {locationDisplay && categoryDisplay && <span className="meta-bullet">•</span>}
                    {categoryDisplay && <span>{categoryDisplay}</span>}
                  </div>
                  <div className="list-preview-meta">
                    <span>{placeCount} {placeLabel}</span>
                    <span className="meta-bullet">•</span>
                    <span>{percentComplete}% visited</span>
                  </div>
                  <button
                    className="btn-restore"
                    onClick={(e) => onRestoreList(e, list.id)}
                    disabled={restoringListId === list.id}
                  >
                    {restoringListId === list.id ? 'Restoring...' : 'Restore'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ArchivedListsSection;
